import React, { useEffect, useRef } from 'react'

import captureVideoFrame from "capture-video-frame"
import screenfull from "screenfull"
import ReactPlayer from 'react-player'

import { useVideo } from '../../CustomHooks/useVideo';

const ReactLivePlayer = ({ item, devid, playUrl, devname, streamName, captureVideoFrameData, isSnapShotBtnClick, setIsSnapShotBtnClick, savedRef, isAlertLiveFullscreenClick, videoContainerParentRefInDiv, fullScreenRef, setFullScreenRef, newVideoRef }) => {
    const { count, setCount, videoStartBuffering, videoStopBuffering, videoErrorHandler, getHeaders } = useVideo();
    const videoRef = useRef(null);

    useEffect(() => {
        if (isSnapShotBtnClick && savedRef == item?.associatedCameraId) {
            setTimeout(() => {
                handleCaptureFrame(videoRef.current.getInternalPlayer())
                setIsSnapShotBtnClick(false)
            }, 2000);
        } else if (isSnapShotBtnClick && savedRef == 0) {
            setTimeout(() => {
                handleCaptureFrame(videoRef.current.getInternalPlayer())
                setIsSnapShotBtnClick(false)
            }, 2000);
        }
    }, [isSnapShotBtnClick])

    useEffect(() => {
        if (fullScreenRef == 0) {
            if (isAlertLiveFullscreenClick) {
                screenfull.toggle(videoContainerParentRefInDiv?.current)
                let c = count + 1;
                setCount(c);
                setFullScreenRef(null);
            } else if (!isAlertLiveFullscreenClick && fullScreenRef != null) {
                screenfull.toggle(videoContainerParentRefInDiv?.current)
                let c = count + 1;
                setCount(c);
                setFullScreenRef(null);
            }
        } else {
            if (isAlertLiveFullscreenClick && fullScreenRef == item?.associatedCameraId) {
                screenfull.toggle(videoContainerParentRefInDiv?.current)
                let c = count + 1;
                setCount(c);
                setFullScreenRef(null);
            } else if (!isAlertLiveFullscreenClick && (fullScreenRef != null && fullScreenRef == item?.associatedCameraId)) {
                screenfull.toggle(videoContainerParentRefInDiv?.current)
                let c = count + 1;
                setCount(c);
                setFullScreenRef(null);
            }
        }
    }, [isAlertLiveFullscreenClick]);

    const handleCaptureFrame = (params) => {
        const video = videoRef.current.getInternalPlayer();

        const frame = captureVideoFrame(video)
        var fileUrl = frame.dataUri;
        captureVideoFrameData(fileUrl)
    };

    return (
        <ReactPlayer
            ref={newVideoRef}
            key={count}
            id={"video-" + devid}
            itemID={"video-" + streamName}
            url={playUrl}
            playing={true}
            className="chatbotliveplayer"
            width={isAlertLiveFullscreenClick ? "100%" : "264px"}
            height={isAlertLiveFullscreenClick ? "100%" : "150px"}
            controls={true}
            autoPlay
            pip={true} // for picture in picture
            stopOnUnmount={false} // for picture in picture
            style={{ backgroundColor: "rgb(189,188,188)", borderRadius: "14px", position: "relative" }}
            onBuffer={(e) => videoStartBuffering(e, devname)}
            onBufferEnd={(e) => videoStopBuffering(e, devname)}
            onError={(e) => videoErrorHandler(e, devname)}
            config={{
                file: {
                    attributes: {
                        controlsList: "noplaybackrate nodownload",
                        crossorigin: 'anonymous',
                        onContextMenu: (e) => e.preventDefault(),
                    },
                    tracks: [],
                    forceVideo: true,
                    forceAudio: true,
                    http: {
                        headers: getHeaders(),
                    },
                },
            }}
        />
    )
}

export default ReactLivePlayer